/* eslint no-undef: "error" */
/* eslint-env browser */
import {_, lockr, uiConstants, utils, qs, jsondiff, React, lodashMergeOverwriteArraysFn} from '@api'
import {configs, site, globalStores} from '@stores'

let bookmarkLockr = null
// const diff = (a, b) =>
//   _.reduce(a, (res, val, key) =>
//       res.concat((_.isPlainObject(val) || _.isArray(val)) && b
//                  ? diff(val, b[key]).map(x => key + '.' + x)
//                  : (!b || val != b[key] ? [key] : [])),
//     [])

const diff = jsondiff.diff

// https://stackoverflow.com/questions/25331030/js-get-second-to-last-index-of
// @ts-ignore
String.prototype.nthLastIndexOf = function (searchString, n) {
  var url = this;
  if (url === null) {
    return -1;
  }
  if (!n || isNaN(n) || n <= 1) {
    return url.lastIndexOf(searchString);
  }
  n--;
  return url.lastIndexOf(searchString, url.nthLastIndexOf(searchString, n) - 1);
}
export default {
  lodashMergeOverwriteArraysFn,
  colorsForImage(imageUrl: string) {
    let colorDark = '#000000'
    let colorLight = 'transparent'
    let autoColor = false

    if (imageUrl && imageUrl.startsWith('#')) {
      const {r, g, b} = utils.hexToRgb(imageUrl)
      //console.log(r, g, b)
      if (r >= 250 && g >= 250 && b >= 250) {
        /*var temp = colorDark
        colorDark = colorLight
        colorLight = temp*/
        // colorLight = data.hex
        // autoColor = true
      } else {
        colorDark = imageUrl
      }
    }

    return {colorDark, colorLight, autoColor}
  },
  buildImageUrl(imageWrapper, size = null) {
    let imageUrl
    if (imageWrapper && imageWrapper.length) {
      const defaultImageWrapper = _.find(imageWrapper, wrapper => wrapper.position === 0)
      if (defaultImageWrapper) {
        const imageEndpoint = defaultImageWrapper.image[`${size}Image`] || defaultImageWrapper.image[`${size}`]
        imageUrl = defaultImageWrapper ? `${configs.config.graphqlEndpoint}images/${imageEndpoint}?token=${lockr.get('access_token')}` : undefined
      }
    }

    return imageUrl
  },
  isJson(str) {
    try {
      if (!_.isString(str)) return false

      JSON.parse(str);
    } catch (e) {
      return false
    }
    return true
  },
  swap(arr, from, to) {
    return arr.splice(from, 1, arr.splice(to, 1, arr[from])[0]);
  },
  parseQs(str: string) {
    return qs.parse(str, {arrayFormat: 'none', decode: true})
  },
  stringifyQs(obj: any) {
    return qs.stringify(obj, {arrayFormat: 'none', encode: true, strict: false})
  },
  parseQuery(queryString) {
    var query = {};
    var pairs = (queryString[0] === '?' ? queryString.substring(1) : queryString).split('&');
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i].split('=');
      if (query[decodeURIComponent(pair[0])]) {
        if (!Array.isArray(query[decodeURIComponent(pair[0])])) {
          const temp = query[decodeURIComponent(pair[0])]
          query[decodeURIComponent(pair[0])] = [temp]
        }
        query[decodeURIComponent(pair[0])].push(decodeURIComponent(pair[1] || ''))
      } else {
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
      }
    }
    return query;
  },
  getImageSrc(images, size = null) {
    let updatedSrc = null
    const token = lockr.get('access_token')
    if (images && images.length > 0) {
      const defaultImageWrapper = _.find(images, wrapper => wrapper.position === 0)
      updatedSrc = size ? `${configs.config.graphqlEndpoint}images/${defaultImageWrapper.image[size]}?token=${token}` : `${configs.config.graphqlEndpoint}images/${defaultImageWrapper.image.thumbnailImage}?token=${token}`
    }
    return updatedSrc
  },
  mapDefaultImageInData(data, imageSize) {
    const itemData = _.cloneDeep(data)
    const imageWrappers = itemData && itemData.images ? itemData.images : []
    // tslint:disable-next-line:no-invalid-this
    let defaultImage = this.getImageSrc(imageWrappers, imageSize || 'smallImage')
    itemData.images = defaultImage ? [defaultImage] : []
    return itemData
  },
  mapImagesInData(data, imageSize) {
    const itemData = _.cloneDeep(data)
    const imageWrappers = itemData && itemData.images ? itemData.images : []
    const sortedImageWrappers = _.sortBy(imageWrappers, ['position'])
    const token = lockr.get('access_token')
    let images = []

    _.forEach((sortedImageWrappers), (imageWrapper) => {
      let imageUrl = imageSize ? `${configs.config.graphqlEndpoint}images/${imageWrapper.image[imageSize]}?token=${token}` : `${configs.config.graphqlEndpoint}images/${imageWrapper.image.thumbnailImage}?token=${token}`
      images.push(imageUrl)
    })

    itemData.images = images
    return itemData
  },
  mapDataImagesForCarousal(data, imageSize) {
    const itemData = _.cloneDeep(data)
    const imageWrappers = itemData && itemData.images ? itemData.images : []
    const sortedImageWrappers = _.sortBy(imageWrappers, ['position'])
    const token = lockr.get('access_token')
    let images = []

    _.forEach((sortedImageWrappers), (imageWrapper) => {
      let imageObject = {
        id: imageWrapper.image.id,
        label: imageWrapper.image.label,
        position: imageWrapper.position,
        imageURL: imageSize ? `${configs.config.graphqlEndpoint}images/${imageWrapper.image[imageSize]}?token=${token}` : `${configs.config.graphqlEndpoint}images/${imageWrapper.image.thumbnailImage}?token=${token}`
      }
      // wrapper.imageUrl = imageSize ? `${configStore.config.graphqlEndpoint}images/${imageWrapper.image[imageSize]}?token=${token}` : `${configStore.config.graphqlEndpoint}images/${imageWrapper.image.thumbnailImage}?token=${token}`
      images.push(imageObject)
    })

    itemData.images = images
    return itemData
  },

  // Forces image download of a URL using a blob object URL unless we are offline
  async downloadImage(url, fileName, isOffline) {    

    if (!fileName) {
      // try to build new filename using fragment from S3 url
      if (url.indexOf('/c8/') !== -1) {        
        fileName = url.split('/c8/')[1]
        if (fileName.indexOf('.') !== -1) {
          fileName = fileName.split('.')[0]
        }
      }
    }

    if (!fileName) fileName = 'download'

    // create anchor tag and pass it the download filename
    const a = document.createElement('a')    
    a.download = `${fileName}.png`

    let blobUrl = null

    // if local images, then we don't need to fetch the image
    if (isOffline) {      
      let updatedURL = url.replace("Download=false", "Download=true")   // This Download=false blocks download from Light box
      updatedURL = updatedURL.replace("LargeImage", "Viewable")         // Remove 'LargeImage' word from downloaded file name
      a.href = updatedURL
    } else {
      // fetch and create blob image url for downloading
      try {
        let response = await fetch(url)
        let blob = await response.blob()
        blobUrl = window.URL.createObjectURL(blob)      
        a.href = blobUrl
      } catch (e) {
        // If anything  goes wrong here, just use the original URL
        a.href = url
      }      
    }

    // In cases where download doesn't work, open in new tab
    a.target = '_blank'
    
    // Add anchor to DOM and "click" it to start download
    document.body.appendChild(a)
    a.click()

    // Kill the blob object URL and remove the anchor
    if (blobUrl) {
      window.URL.revokeObjectURL(blobUrl);
    }
    document.body.removeChild(a)
  },

  guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1)
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
  },
  diff,
  hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  },

  // async timeout helper
  sleep(ms) { return new Promise(resolve => setTimeout(resolve, ms))},

  // LZW-compress a string
  lzw_encode(s) {
    var dict = {};
    var data = (s + "").split("");
    var out = [];
    var currChar;
    var phrase = data[0];
    var code = 256;
    for (var i = 1; i < data.length; i++) {
      currChar = data[i];
      if (dict[phrase + currChar] != null) {
        phrase += currChar;
      } else {
        out.push(phrase.length > 1 ? dict[phrase] : phrase.charCodeAt(0));
        dict[phrase + currChar] = code;
        code++;
        phrase = currChar;
      }
    }
    out.push(phrase.length > 1 ? dict[phrase] : phrase.charCodeAt(0));
    for (var i = 0; i < out.length; i++) {
      out[i] = String.fromCharCode(out[i]);
    }
    return out.join("");
  },

  // Decompress an LZW-encoded string
  lzw_decode(s) {
    var dict = {};
    var data = (s + "").split("");
    var currChar = data[0];
    var oldPhrase = currChar;
    var out = [currChar];
    var code = 256;
    var phrase;
    for (var i = 1; i < data.length; i++) {
      var currCode = data[i].charCodeAt(0);
      if (currCode < 256) {
        phrase = data[i];
      } else {
        phrase = dict[currCode] ? dict[currCode] : (oldPhrase + currChar);
      }
      out.push(phrase);
      currChar = phrase.charAt(0);
      dict[code] = oldPhrase + currChar;
      code++;
      oldPhrase = phrase;
    }
    return out.join("");
  },

  waitFor(condition: () => boolean, interval = 100) {
    return new Promise<void>((resolve) => {
      const handle = setInterval(() => {
        if (condition()) {
          clearInterval(handle);
          resolve();
        }

      }, interval)
    })
  },

  isEmptyString(str) {
    return !str || !/\S/.test(str);
  },
  plmLinkFor({exId}: { exId: any }) {
    return utils.plmLinkForId(exId)
  },
  plmLinkForId(id: string) {
    const {ui: {settings: {c8: {sso}}}, authStore: {user: {sessionUrl}}} = globalStores
    return `${configs.config.centricURL}/WebAccess/home.html#URL=${id}${sso ? `&SessionURL=${sessionUrl}` : ''}`
  },

  openDataImgInNewTab(dataImg: string) {
    const newTab = window.open()
    newTab.document.body.innerHTML = `<img src='${dataImg}' >`
  },
  array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  },
  recursiveGet(data: any, field: string) {
    const fields = field.split('.'),
      f = fields[0],
      remaining = fields.length > 1 ? fields.slice(1).join('.') : null

    const d = _.get(data, f)
    if (!remaining) {
      return !d ? d : _.isArray(d) ? d.map(v => ({...v, __parent: data})) : {...d, __parent: data}
    }

    if (_.isArray(d)) {
      return d.map(v => this.recursiveGet(v, remaining))
    } else {
      return this.recursiveGet(d, remaining)
    }
  },
  eatMouseEvent(e: React.MouseEvent) {
    e.preventDefault()
    e.stopPropagation()
  },
  eatKeyboardEvent(e: React.KeyboardEvent) {
    e.stopPropagation()
  },
  deepFreeze(object) {
    // Retrieve the property names defined on object
    const propNames = Object.getOwnPropertyNames(object);

    // Freeze properties before freezing self

    for (const name of propNames) {
      const value = object[name];

      if (value && typeof value === "object") {
        this.deepFreeze(value);
      }
    }

    return Object.freeze(object);
  },
  isWindows: navigator.platform === 'Win32',
  isSafari: navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
            navigator.userAgent &&
            navigator.userAgent.indexOf('CriOS') == -1 &&
            navigator.userAgent.indexOf('FxiOS') == -1,
  isFirefox: navigator.userAgent?.includes('Firefox/'),

  getUniqueBookmarkLockrKeyForCurrentLogin() {
    return bookmarkLockr || (bookmarkLockr = '-' + Math.random().toString(36).substring(7))
  },
  isNullOrUndefined: (value) => _.isNull(value) || _.isUndefined(value),
  removeTags: function (str: string) {
    if ((str === null) || (str === ''))
      return false;
    else
      str = str.toString();
    return str.replace(/(<([^>]+)>)/ig, '');
  },
  enlist: <T>(v: T | Array<T>): Array<T> => v instanceof Array ? v : [v],
  toCapitalizedWords: (name) => {
    var words = name.match(/[A-Za-z][a-z]*/g) || [];

    return words.map(_.capitalize).join(" ");
  },
  getTextWidth: (text, font) => {
    // re-use canvas object for better performance
    site.canvas = site.canvas || document.createElement('canvas')
    site.canvas.setAttribute('id', 'tempCanvas')
    let context = site.canvas.getContext('2d')
    context.font = font
    let metrics = context.measureText(text)
    // document.getElementById("tempCanvas").outerHTML = ""
    return Math.floor(metrics.width)
  },
  async suppressChromeSetTimeoutTookWarning() {
    // suppress chrome violations message
    // https://stackoverflow.com/questions/42218699/chrome-violation-violation-handler-took-83ms-of-runtime
    return await utils.sleep(1)
  },
  findLastIndexLtoR: function <T>(arr: Array<T>, predicate: (item: T) => boolean, startIndex: number) {
    let r = -1
    for (var i = startIndex; i < arr.length; i++) {
      if (!predicate(arr[i])) break
      r = i
    }

    return r
  },
  isCentricID(id: string | boolean) {
    return id && _.isString(id) ? id.match(/^C[0-9]/) != null : false
  }
}




// WEBPACK FOOTER //
// ./src/modules/common/utils.ts